var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowLoading)?_c('div',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('span',[(!_vm.isGetAllData)?_c('a-icon',{attrs:{"type":"loading"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.isGetAllData ? '没有更多数据了。' : '加载数据。 ')+"\n  ")],1)]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }